import script from "./AdminUsersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminUsersPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminUsersPage.vue?vue&type=style&index=0&id=5dbbf503&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dbbf503"]])

export default __exports__